import React from 'react'
import {useTranslation} from 'react-i18next'
import {
  Checkbox,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import {makeStyles} from '@material-ui/core/styles'
import useInvoiceView from 'features/invoice/useInvoiceView'
import InvoiceViewStyle from 'pages/CustomerManagement/InvoiceView/Style'
import {USAGE_DETAIL_HEAD} from 'pages/CustomerManagement/InvoiceView/constant'
import {localDateToUtcString} from 'helpers/dateHelper'
import useProductManagement from 'features/productManagement/useProductManagement'
import {LicenseAnalyzeStatus} from 'api/productApi'

const useStyles = makeStyles(InvoiceViewStyle)

interface UsageDetailProps {
  listCheckedId?: string[]
  onCheckItem: (usageId: string, price: number) => void
  onCheckAll: (checked: boolean) => void
}

function UsageDetail(props: UsageDetailProps) {
  const {t, i18n} = useTranslation()
  const {listCheckedId = [], onCheckItem, onCheckAll} = props
  const classes = useStyles()
  const {usageSummaryTable} = useInvoiceView()
  const {listAllPackage} = useProductManagement()

  const getInfoPackage = (packageId: string) => {
    const item = listAllPackage?.find((pkg) => pkg.itemId === packageId)
    if (item) {
      return (
        item.displayInfos.find(
          (it) => it.langCode === (i18n.language === 'ko' ? 'ko' : 'en'),
        )?.name || ''
      )
    }
    return ''
  }

  const getAnalysisStatus = (status: LicenseAnalyzeStatus) => {
    switch (status) {
      case 'COMPLETED':
        return t('IComplete')
      case 'CANCELLED':
        return t('ICancelled')
      case 'FAILED':
        return t('IFailed')
      case 'IN_PROGRESS':
        return t('IInProgress')
      case 'REQUESTED':
        return t('IRequested')
      default:
        return t('IComplete')
    }
  }

  const allChecked = usageSummaryTable.every((item) =>
    item.usageLogs.every((usage) => listCheckedId.includes(usage.usageId)),
  )

  return (
    <div className={classes.defaultBilling} style={{marginTop: 5}}>
      <div className={classes.defaultBillingTitle}>{t('IUsageDetail')}</div>
      <div className={classes.defaultBillingTable}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.header} ${classes.backGroundHead}`}
              >
                <Checkbox
                  checked={allChecked}
                  onChange={() => onCheckAll(!allChecked)}
                />
              </TableCell>
              {USAGE_DETAIL_HEAD.map((item) => (
                <TableCell
                  key={item.id}
                  className={`${classes.header} ${classes.backGroundHead}`}
                >
                  {t(item.label)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {usageSummaryTable
              .flatMap((data) => data.usageLogs)
              .map((usage, usageIndex) => (
                <TableRow key={`${usage.usageId}-${usageIndex}`}>
                  <TableCell className={classes.cell}>
                    <Checkbox
                      checked={listCheckedId.includes(usage.usageId)}
                      onChange={() =>
                        onCheckItem(
                          usage.usageId,
                          usage.packagePrice * usage.usageQuantity,
                        )
                      }
                    />
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {usageIndex + 1}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {localDateToUtcString(new Date(usage.usageDateTime))}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {getInfoPackage(usage.packageItemId)}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {usage.usageId}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {getAnalysisStatus(usage.analyzeStatus)}
                  </TableCell>
                  <TableCell className={classes.cell} />
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default UsageDetail
